import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { AuthService } from 'app/services/user/auth.service';
import { LoyaltyClusterTypeService } from 'app/services/loyalty/loyalty-cluster-type.service';
import * as moment from 'moment';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { Cluster, ClusterHead, OChannel } from '../../../../models/loyalty-cluster.model';
import { KoncentroValidators } from "../../../../modules/UIKit/validators/koncentro-validators";
import { LoyaltyClusterHeadService } from '../../../../services/loyalty/loyalty-cluster-head.service';
import { LoyaltyClusterOchannelService } from '../../../../services/loyalty/loyalty-cluster-ochannel.service';
import { LoyaltyClusterService } from '../../../../services/loyalty/loyalty-cluster.service';
import { PromotionOchannelService } from '../../../../services/promotion/promotion-ochannel.service';
import { KontableComponent } from '../../../../modules/UIKit/components/kontable/kontable.component';


@Component({
  selector: 'app-form-cluster-loyalty',
  templateUrl: './form-cluster-loyalty.component.html',
  styleUrls: ['./form-cluster-loyalty.component.css']
})
export class FormClusterLoyaltyComponent implements OnInit {

  public validators = {
    noSpecialCharacters: KoncentroValidators.noSpecialCharacters,
    notNull: Validators.nullValidator
  };
  form: FormGroup;
  @Input() clusterId: string;
  @Input() clusterHeadId: string;
  @Input() editMode: boolean;
  @Input() backButton: boolean = true;
  @Input() isPopUp: boolean = false;
  @Output() closePopUp: EventEmitter<any> = new EventEmitter<any>();
  serverPagination = KontableComponent.ServerPagination;
  clientPagination = KontableComponent.ClientPagination;
  initialFilters = [];
  customFilter = KontableComponent.CustomFilter;
  dateFilter = KontableComponent.DateFilter;
  noFilter = KontableComponent.NoFilter;
  textFilter = KontableComponent.TextFilter;
  numberFilter = KontableComponent.NumberFilter;

  selectFilter = KontableComponent.SelectFilter;
  oChannelFrom: Array<FormGroup>;
  showModaleOChannel: boolean;
  listPromotionOchannel: Array<{ label: string, value: number }>;
  listClusterType: Array<{ label: string, value: number }>;
  validationCluster: any;
  validationClusterHead: any;
  validationClusterHeadOChannel: any;
  dateStartIssue = false;
  dateEndIssue = false;
  dateStartMax = null;
  dateEndMin = null;
  dateStartMin = null;
  showActionModal: boolean = false;
  selectedHead: FormGroup = null;
  selectedHeadIndex: number = 0;
  selectedHeadStatus: string = '';
  showPeriodModal: boolean = false;
  currentPeriodForm: FormGroup = null;
  currentPeriodIndex: number = -1;
  modalDefaultStartDate: Date = null;
  modalDefaultEndDate: Date = null;
  modalPeriodStatus: string = '';
  modalCustomEndDate: Date = null;
  originalStartDate: Date = null;
  originalEndDate: Date = null;
  dateEndSub: any;
  dateStartSub: any;
  calculatedCustomersCount: number | null = null;
  tableDataObjects: any[] = null;
  statusOptions: any[] = [];
  isLoadingHeadComplete: boolean = false;
  isLoadingExport: boolean = false;
  currentOChannelClusterHeadId: string = null;
  currentOChannelDateStart: Date = null;
  currentOChannelDateEnd: Date = null;

  fireNewDataAvailable = false;
  clusterHeadListService: any = null;
  invalidSubmit: boolean = false;

  fields = {
    title: 'Cluster',
    description: 'cluster.description',
    type: 'cluster.type',
    date_start: 'cluster_head.date_start',
    date_end: 'cluster_head.date_end',
    depends_on: 'cluster_head.depends_on',
    exclude: 'cluster_head.exclude',
    description_head: 'cluster_head.description',
    ochannel: 'cluster_ochannel.ochannel',
    description_ochannel: 'cluster_ochannel.description',
    conversion_code: 'cluster_ochannel.conversion_code',
    touch_point: 'cluster_ochannel.touch_point',
    validityTime: 'cluster.validityTime',
    code: 'cluster.code',
    status: 'cluster_head.status',
    total_clients: 'cluster_head.total_clients',
    active_clients: 'cluster_head.active_clients',
    actions: 'cluster_head.actions',
    exportMessage: 'cluster_head.export_message'
  };

  defaultStartDate: Date[] = [];
  defaultEndDate: Date[] = [];
  directActiveValues: SelectItem[];
  directActiveTouchPoints: any = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private clusterService: LoyaltyClusterService,
    private clusterHeadService: LoyaltyClusterHeadService,
    private oChannelService: LoyaltyClusterOchannelService,
    private oChannelPromotionService: PromotionOchannelService,
    private clusterTypeService: LoyaltyClusterTypeService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) { }

  get ochannels(): FormArray {
    return this.form.get('ochannels') as FormArray;
  }

  ngOnInit() {
    this.oChannelFrom = [];
    this.listPromotionOchannel = [];
    this.listClusterType = [];
    this.showModaleOChannel = false;

    this.listClusterType.push({ value: null, label: '' });

    this.clusterId = this.activatedRoute.snapshot.params['clusterId'];
    this.editMode = (typeof this.clusterId !== 'undefined');
    this.listPromotionOchannel.push({ label: '', value: null });
    this.clusterHeadListService = this.clusterHeadService;
    this.clusterHeadListService.clusterId = this.clusterId;

    this.directActiveValues = [
      { label: this.translateService.instant('shoppingList.no'), value: 0 },
      { label: this.translateService.instant('shoppingList.yes'), value: 1 },
      { label: this.translateService.instant('cluster_ochannel.yesConfirm'), value: 2 }
    ];

    this.translateService.get(['status.active', 'status.expired', 'status.future']).subscribe(translations => {
      this.statusOptions = [
        { label: '', value: '' },
        { label: translations['status.active'], value: 'active' },
        { label: translations['status.expired'], value: 'expired' },
        { label: translations['status.future'], value: 'future' }
      ];
    });

    this.fields.title = (this.editMode) ? 'cluster.edit_title' : 'cluster.add_title';

    if (this.clusterId) {
      this.clusterHeadService.clusterId = this.clusterId;
      this.clusterHeadListService = this.clusterHeadService;
    }

    let cluster: Observable<Cluster>;
    let clusterHeadObs: Observable<any>;
    let OChannelPromotion: Observable<any>;
    let ClusterTypes: Observable<any>;

    let ValidationCluster: Observable<any>;
    let ValidationClusterHead: Observable<any>;
    let ValidationClusterHeadOChannel: Observable<any>;

    this.isLoadingHeadComplete = this.editMode; // Mostra loading solo in editMode (quando chiamiamo l'API)

    if (!this.editMode) {
      cluster = Observable.of(new Cluster());
      clusterHeadObs = Observable.of([]);
    } else {
      cluster = this.clusterService.get(this.clusterId);
      clusterHeadObs = this.clusterHeadService.list();
    }

    OChannelPromotion = this.oChannelPromotionService.list();
    ClusterTypes = this.clusterTypeService.getAll();

    ValidationCluster = this.clusterService.getFields();
    ValidationClusterHead = this.clusterHeadService.getFields();
    ValidationClusterHeadOChannel = this.oChannelService.getFields();

    Observable.zip(
      cluster,
      clusterHeadObs,
      ClusterTypes,
      ValidationCluster,
      ValidationClusterHead,
      ValidationClusterHeadOChannel
    ).subscribe(([res, resClusterHeads, resClusterType, resValidationCluster, resValidationClusterHead, resValidationClusterHeadOChannel]) => {

      this.validationCluster = resValidationCluster;
      this.validationClusterHead = resValidationClusterHead;
      this.validationClusterHeadOChannel = resValidationClusterHeadOChannel;

      for (const clusterType of resClusterType.data) {
        this.listClusterType.push({ value: clusterType.id, label: clusterType.code + ' - ' + clusterType.description });
      }

      const headsFormArray = this.fb.array([]);
      if (resClusterHeads && Array.isArray(resClusterHeads)) {
        resClusterHeads.forEach((headData: any) => {
          headsFormArray.push(this.fb.group(this.getClusterHead(headData, 'YYYY-MM-DD')));
        });
      }

      this.tableDataObjects = resClusterHeads.data || resClusterHeads.rsp_data || resClusterHeads || [];
      this.fireNewDataAvailable = !this.fireNewDataAvailable;
      this.isLoadingHeadComplete = false;

      this.form = this.fb.group({
        clusterHeadId: res.id,
        description: res.description,
        cluster_type_id: res.cluster_type_id,
        code: res.code,
        heads: headsFormArray,
        ochannels: this.fb.array(this.oChannelFrom),
        status: resClusterHeads && resClusterHeads.status ? resClusterHeads.status : null
      });

      OChannelPromotion.subscribe(promoRes => {
        setTimeout(() => {
          if (promoRes) {
            for (const oChannelPromotion of promoRes) {
              this.listPromotionOchannel.push({ value: oChannelPromotion.id, label: oChannelPromotion.description });
            }
          } else {
            console.error('res.data promo/ochannel/list is undefined');
          }
        }, 1000);
      });

      this.cdr.detectChanges();
    });
  }

  getClusterHead(clusterHead: ClusterHead, formatDate: string) {


    let dtStart = clusterHead.date_start;
    let dtEnd = clusterHead.date_end;
    if (moment(clusterHead.date_start, 'DD/MM/YYYY', true).isValid()) {
      console.debug("Data formattata correttamente");
    } else {
      // Se il primo formato non è valido, provo il secondo formato
      if (moment(clusterHead.date_start, 'YYYY-MM-DD', true).isValid()) {
        dtStart = moment(clusterHead.date_start, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
    }
    if (moment(clusterHead.date_end, 'DD/MM/YYYY', true).isValid()) {
      console.debug("Data formattata correttamente");
    } else {
      // Se il primo formato non è valido, provo il secondo formato
      if (moment(clusterHead.date_end, 'YYYY-MM-DD', true).isValid()) {
        dtEnd = moment(clusterHead.date_end, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }

    }
    if (dtStart) {
      this.defaultStartDate.push(moment(dtStart, 'DD/MM/YYYY').toDate());
    }

    if (dtEnd) {
      this.defaultEndDate.push(moment(dtEnd, 'DD/MM/YYYY').toDate());
    }
    const ch: any = clusterHead;

    let form = {
      id: [ch.id || null],
      cluster_head_id: [ch.clusterHeadId || null],
      description: [ch.clusterDescription || ch.description || ''],
      date_start: [dtStart],
      date_end: [dtEnd],
      depends_on_cluster_head_id: [ch.depends_on_cluster_head_id || null],
      exclude_cluster_head_id: [ch.exclude_cluster_head_id || null],
      total_customers: [ch.totalCustomers || ch.total_customers || 0],
      active_customers: [ch.totalActiveCustomers || ch.active_customers || 0],
      update_customers_dates: [ch.update_customers_dates || ch.updateCustomersDates || false],
      update_customers_type: [ch.update_customers_type || ch.updateCustomersType || 'ONLY_ACTIVE'],
      update_customers_custom_date: [ch.update_customers_custom_date || ch.updateCustomersCustomDate || null]
    };

    console.log(JSON.stringify(form));
    return form;

  }

  getClusterOChannel(oChannel: OChannel) {

    let form = {
      id: [oChannel.id || null],
      cluster_head_id: [oChannel.cluster_head_id || this.clusterHeadId],
      conversion_code: [oChannel.conversion_code || '', Validators.required],
      description: [oChannel.description || '', Validators.required],
      ochannel_id: [oChannel.ochannel_id || '', Validators.required],
      icon_b64: [oChannel.icon_b64 || null],
      icon_url: [oChannel.icon_url || ''],
      flg_direct_active: [oChannel.flg_direct_active || '0']
    };

    return form;
  }

  backBtn() {
    this.router.navigate(['/loyalty/cluster']);
  }


  save() {
    // 1. Controlli di validità di base (Form e Code)
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    if (!this.form.get('code').value) {
      this.invalidSubmit = true;
      this.messageService.add({ severity: 'error', summary: this.translateService.instant('common.error'), detail: this.translateService.instant('cluster.codeError') });
      return;
    }


    this.invalidSubmit = false;


    const cluster = new Cluster();
    cluster.description = this.form.get('description').value;
    cluster.code = this.form.get('code').value;
    cluster.cluster_type_id = this.form.get('cluster_type_id').value;

    this.messageService.add({ severity: 'info', summary: this.translateService.instant('common.saving'), detail: this.translateService.instant('cluster.saving_detail') });

    //  Chiamate API
    if (!this.editMode) {
      // === CREAZIONE ===
      this.clusterService.create(cluster).subscribe(
        (res) => {
          this.clusterId = res.id;
          this.clusterHeadService.clusterId = res.id;
          this.clusterHeadListService.clusterId = res.id;
          this.editMode = true;
          this.fields.title = 'cluster.edit_title';

          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('common.success'),
            detail: this.translateService.instant('cluster.creation_success')
          });

        },
        (err) => {
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('common.error'),
            detail: this.translateService.instant('cluster.cluster_creation_error')
          });
        }
      );

    } else {
      // === MODIFICA ===
      cluster.id = this.clusterId;
      this.clusterService.update(cluster).subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('common.success'),
            detail: this.translateService.instant('cluster.cluster_update_success')
          });

          // Usciamo dalla pagina dopo aver salvato le modifiche generali
          if (this.isPopUp) {
            this.closePopUp.emit();
          } else {
            this.router.navigate(['/loyalty/cluster/']);
          }
        },
        (err) => {
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('common.error'),
            detail: this.translateService.instant('cluster.cluster_update_error')
          });
        }
      );
    }
  }

  aggiungi() {

    this.dateStartIssue = false;
    this.currentPeriodForm = this.fb.group(
      this.getClusterHead(new ClusterHead(), 'DD/MM/YYYY')
    );
    this.calculatedCustomersCount = null;

    this.currentPeriodForm.enable();

    this.currentPeriodForm.get('date_start').setValue('');
    this.currentPeriodForm.get('date_end').setValue('');

    // Sicurezza: prendiamo l'ultima data solo se l'array non è vuoto
    const lastIndexStart = this.defaultStartDate.length > 0 ? this.defaultStartDate.length - 1 : -1;
    this.modalDefaultStartDate = lastIndexStart >= 0 ? this.defaultStartDate[lastIndexStart] : new Date();

    const lastIndexEnd = this.defaultEndDate.length > 0 ? this.defaultEndDate.length - 1 : -1;
    this.modalDefaultEndDate = lastIndexEnd >= 0 ? this.defaultEndDate[lastIndexEnd] : new Date();

    this.currentPeriodIndex = -1;
    this.modalPeriodStatus = 'New';
    this.showPeriodModal = true;

  }

  savePeriodModal() {
    if (this.dateStartSub) this.dateStartSub.unsubscribe();
    if (this.dateEndSub) this.dateEndSub.unsubscribe();

    this.dateStartIssue = false;

    if (!this.currentPeriodForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    const updatedValue = this.currentPeriodForm.getRawValue();

    // Controllo validità temporale
    if (updatedValue.date_start && updatedValue.date_end) {
      const start = moment(updatedValue.date_start, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]);
      const end = moment(updatedValue.date_end, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]);

      if (start.isValid() && end.isValid() && start.isAfter(end, 'day')) {
        this.invalidSubmit = true;
        this.dateStartIssue = true;
        return;
      }
    }

    const payload = { ...updatedValue };
    if (payload.date_start) payload.date_start = moment(payload.date_start, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD');
    if (payload.date_end) payload.date_end = moment(payload.date_end, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD');
    if (payload.update_customers_custom_date) payload.update_customers_custom_date = moment(payload.update_customers_custom_date, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD');

    payload.code = this.form.get('code').value;

    if (updatedValue.date_start) updatedValue.date_start = moment(payload.date_start, 'YYYY-MM-DD').format('DD/MM/YYYY');
    if (updatedValue.date_end) updatedValue.date_end = moment(payload.date_end, 'YYYY-MM-DD').format('DD/MM/YYYY');
    if (updatedValue.update_customers_custom_date) updatedValue.update_customers_custom_date = moment(payload.update_customers_custom_date, 'YYYY-MM-DD').format('DD/MM/YYYY');



    const cleanApiPayload = {
      description: payload.description,
      date_start: payload.date_start,
      date_end: payload.date_end,
      code: payload.code,
      total_customers: payload.total_customers,
      active_customers: payload.active_customers
    };


    const periodId = payload.id || payload.cluster_head_id;
    // CASO A: Modifica di un cluster head GIÀ ESISTENTE (Ha l'id) -> Chiamata API in tempo reale
    if (this.clusterId && periodId && this.currentPeriodIndex !== -1) {
      const modifyCustomers = payload.update_customers_dates === true;

      this.messageService.add({
        severity: 'info',
        summary: this.translateService.instant('common.saving'),
        detail: this.translateService.instant('cluster_head.updating_cluster_head')
      });

      this.clusterHeadService.update(this.clusterId, periodId, cleanApiPayload, modifyCustomers).subscribe(
        (_res) => {
          this.clusterHeadService.list().subscribe((updatedHeads: any) => {
            this.tableDataObjects = updatedHeads.data || updatedHeads.rsp_data || updatedHeads || [];
            this.fireNewDataAvailable = !this.fireNewDataAvailable;
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('common.success'),
              detail: this.translateService.instant('cluster_head.update_cluster_head_success')
            });
            this.chiudiEresettaModale();
          });
        },
        (err) => {
          console.error("ERRORE API MODIFICA:", err);
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('common.error'),
            detail: this.translateService.instant('cluster_head.update_error')
          });
        }
      );

      // CASO B: Nuovo cluster head
    } else {

      this.messageService.add({ severity: 'info', summary: this.translateService.instant('common.saving'), detail: this.translateService.instant('cluster_head.creation_detail') });


      this.clusterHeadService.create(this.clusterId, cleanApiPayload).subscribe(
        (_res: any) => {
          this.clusterHeadService.list().subscribe((updatedHeads: any) => {
            this.tableDataObjects = updatedHeads.data || updatedHeads.rsp_data || updatedHeads || [];
            this.fireNewDataAvailable = !this.fireNewDataAvailable;
            this.messageService.add({ severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('cluster_head.creation_success') });
            this.chiudiEresettaModale();
          });
        }
      );
    }
  }


  private chiudiEresettaModale() {
    this.showPeriodModal = false;
    this.currentPeriodForm = null;
  }

  annullaPeriodModal() {
    if (this.dateStartSub) this.dateStartSub.unsubscribe()
    if (this.dateEndSub) this.dateEndSub.unsubscribe();

    this.showPeriodModal = false;
    this.currentPeriodForm = null;
  }

  editPeriodModal(row: any) {
    this.dateStartIssue = false;
    const rawValues = {
      cluster_head_id: row.clusterHeadId,
      description: row.clusterDescription,
      date_start: row.date_start,
      date_end: row.date_end,
      total_customers: row.totalCustomers,
      active_customers: row.totalActiveCustomers,
      update_customers_dates: false,
      update_customers_type: 'ONLY_ACTIVE',
      update_customers_custom_date: null
    };

    this.currentPeriodForm = this.fb.group(this.getClusterHead(rawValues, 'DD/MM/YYYY'));
    this.currentPeriodForm.patchValue(rawValues);
    this.calculatedCustomersCount = null;

    this.originalStartDate = rawValues.date_start;
    this.originalEndDate = rawValues.date_end;

    this.modalDefaultStartDate = rawValues.date_start ? moment(rawValues.date_start, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate() : new Date();
    this.modalDefaultEndDate = rawValues.date_end ? moment(rawValues.date_end, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate() : new Date();
    this.modalCustomEndDate = null;

    const status = row.status ? (row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase()) : '';
    this.modalPeriodStatus = status;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (status === 'Active') {
      this.dateEndMin = today;
      this.dateStartMin = null;

      this.currentPeriodForm.get('description').enable();
      this.currentPeriodForm.get('date_start').disable();
      this.currentPeriodForm.get('date_end').enable();

      // 1. All'apertura, la data non è ancora stata modificata: blocchiamo e resettiamo la checkbox
      this.currentPeriodForm.get('update_customers_dates').disable();
      this.currentPeriodForm.get('update_customers_dates').setValue(false);

      // 2. Puliamo eventuali ascolti precedenti
      if (this.dateEndSub) {
        this.dateEndSub.unsubscribe();
      }

      // 3. Mettiamoci in ascolto di ogni singolo click sul calendario "Data Fine"
      this.dateEndSub = this.currentPeriodForm.get('date_end').valueChanges.subscribe(newDate => {
        if (newDate && this.originalEndDate) {
          // Uniformiamo i formati per poterli confrontare in sicurezza
          const formattedNewDate = moment(newDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY');
          const formattedOrigDate = moment(this.originalEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY');

          if (formattedNewDate !== formattedOrigDate) {
            // Se le date sono diverse, SBLOCCA la checkbox
            this.currentPeriodForm.get('update_customers_dates').enable();
            this.currentPeriodForm.markAsDirty();
          } else {
            // Se l'utente rimette la data originale, BLOCCA e TOGLI la spunta
            this.currentPeriodForm.get('update_customers_dates').disable();
            this.currentPeriodForm.get('update_customers_dates').setValue(false);
          }
        }
      });

    } else if (status === 'Future') {
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.dateStartMin = tomorrow;
      this.dateEndMin = null;

      this.currentPeriodForm.get('description').enable();
      this.currentPeriodForm.get('date_start').enable();
      this.currentPeriodForm.get('date_end').enable();


      this.currentPeriodForm.get('update_customers_dates').disable();
      this.currentPeriodForm.get('update_customers_dates').setValue(false);
      this.currentPeriodForm.get('update_customers_type').setValue(null);


      if (this.dateStartSub) {
        this.dateStartSub.unsubscribe();
      }
      if (this.dateEndSub) {
        this.dateEndSub.unsubscribe();
      }


      const checkBothDates = () => {
        const newStartDate = this.currentPeriodForm.get('date_start').value;
        const newEndDate = this.currentPeriodForm.get('date_end').value;


        const formattedNewStart = newStartDate ? moment(newStartDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;
        const formattedOrigStart = this.originalStartDate ? moment(this.originalStartDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;


        const formattedNewEnd = newEndDate ? moment(newEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;
        const formattedOrigEnd = this.originalEndDate ? moment(this.originalEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;


        if ((formattedNewStart !== formattedOrigStart) || (formattedNewEnd !== formattedOrigEnd)) {

          this.currentPeriodForm.get('update_customers_dates').enable();
          this.currentPeriodForm.markAsDirty();
        } else {

          this.currentPeriodForm.get('update_customers_dates').disable();
          this.currentPeriodForm.get('update_customers_dates').setValue(false);
          this.currentPeriodForm.get('update_customers_type').setValue(null);
        }
      };


      this.dateStartSub = this.currentPeriodForm.get('date_start').valueChanges.subscribe(() => checkBothDates());
      this.dateEndSub = this.currentPeriodForm.get('date_end').valueChanges.subscribe(() => checkBothDates());
    }

    this.currentPeriodIndex = 1; // non -1: indica che stiamo modificando un elemento esistente
    this.showPeriodModal = true;
  }

  resetRadioChoice() {
    this.currentPeriodForm.get('update_customers_type').setValue(null);
    this.calculatedCustomersCount = null;
  }

  aggiungiOChannel() {

    let newFormOChannel = this.fb.group(
      this.getClusterOChannel(new OChannel())
    )
    this.ochannels.push(newFormOChannel);
  }

  deleteHead(row: any) {
    this.confirmationService.confirm({
      message: this.translateService.instant('cluster_head.delete_message'),
      header: this.translateService.instant('cluster_head.confirm_delete'),
      icon: 'fa fa-exclamation-triangle',
      acceptLabel: this.translateService.instant('common.confirm'),
      rejectLabel: this.translateService.instant('common.cancel'),
      accept: () => {
        const idToDelete = row.clusterHeadId || row.id;
        if (!idToDelete) {
          this.fireNewDataAvailable = !this.fireNewDataAvailable;
          return;
        }
        this.clusterHeadService.remove(this.clusterId, idToDelete).subscribe(() => {
          this.clusterHeadService.list().subscribe((updatedHeads: any) => {
            this.tableDataObjects = updatedHeads.data || updatedHeads.rsp_data || updatedHeads || [];
            this.fireNewDataAvailable = !this.fireNewDataAvailable;
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('common.delete_ok'),
              detail: this.translateService.instant('cluster_head.delete_success')
            });
          });
        });
      },
      reject: () => { }
    });
  }




  deleteOChannel(i: number, oChannel: AbstractControl) {
    if (!oChannel.get('id').value) {
      this.ochannels.removeAt(i);
      return;
    }
    this.oChannelService.remove(oChannel.get('id').value).subscribe(() => {
      this.ochannels.removeAt(i);
    });
  }

  getOChannelFromHead(row: any) {
    const clusterHeadId = row.clusterHeadId || row.id;
    this.currentOChannelClusterHeadId = clusterHeadId;
    this.currentOChannelDateStart = row.date_start;
    this.currentOChannelDateEnd = row.date_end;
    this.oChannelFrom = [];
    this.oChannelService.list(clusterHeadId).subscribe((res) => {

      while (this.ochannels.length !== 0) {
        this.ochannels.removeAt(0);
      }

      if (res && res.data) {
        for (const ochannel of res.data) {
          let ochannelForm = this.fb.group(this.getClusterOChannel(ochannel));

          this.ochannels.push(ochannelForm);
        }
      }


      this.showModaleOChannel = true;
    });

    this.oChannelService.getOchannelByParamGroup().subscribe(res => {
      if (res) {
        res.forEach(touchpoint => {
          this.directActiveTouchPoints.push(touchpoint.param_code);
        });
      }
    })
  }

  checkOchannel(ochannel) {
    let check = false;
    this.directActiveTouchPoints.forEach(touchpoint => {
      if (ochannel.ochannel_id == touchpoint) {
        check = true;
      }
    });
    return check;
  }

  async addOChannel() {

    const Ochannels = this.form.get('ochannels').value;
    if (Ochannels.length > 0) {
      const requests = [];
      let response = null;
      let conversionCodeExist = false;
      let touchpointExist = false;

      //inserire le date
      const startDate = this.currentOChannelDateStart ? moment(this.currentOChannelDateStart, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;
      const endDate = this.currentOChannelDateEnd ? moment(this.currentOChannelDateEnd, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('DD/MM/YYYY') : null;

      for (const ochannel of Ochannels) {

        ochannel.cluster_head_id = this.currentOChannelClusterHeadId;
        //Controllo sul conversionCode inserito e sul touchpoint inserito
        response = await this.clusterHeadService.checkClusterHead(ochannel.conversion_code, ochannel.ochannel_id, startDate, endDate).toPromise();
        if (response.length > 0) {
          console.log('RESPONSE FROM BACKEND: ', response);
          for (const clusterHead of response) {

            if (clusterHead.clusterHeadId != ochannel.cluster_head_id) {

              if (clusterHead.conversionCode == ochannel.conversion_code) {
                conversionCodeExist = true;

                this.confirmationService.confirm({
                  message: this.translateService.instant('customerCluster.clusterHeadWarning', { ochannelDescription: clusterHead.ochannelDescription }),
                  accept: () => null,
                  acceptLabel: "Ok",
                  rejectVisible: false
                });
                break;
              }
            }
          }
        }
      }
      // se c'è un errore mostro un messaggio e blocco il salvataggio
      if (conversionCodeExist || touchpointExist) {
        return;
      }

      for (const ochannel of Ochannels) {

        if (!ochannel.id) {
          delete ochannel.id;
          //requests.push(this.oChannelService.create(this.clusterHeadId, ochannel));
          requests.push(this.oChannelService.create(ochannel));
        } else {
          if (!this.checkOchannel(ochannel)) {
            ochannel.flg_direct_active = '0';
          }
          //delete  ochannel.id;
          requests.push(this.oChannelService.update(ochannel));
        }
      }
      Observable.zip(...requests).subscribe();
      if (!conversionCodeExist) {
        this.showModaleOChannel = false;
      }
    } else {
      this.showModaleOChannel = false;
    }
  }
  onIconUpload(event, index) {
    if (event.files[0]) {
      var reader = new FileReader();
      var self = this;
      reader.onloadend = function () {
        self.ochannels.controls[index].get('icon_b64').setValue(reader.result);
      }
      reader.readAsDataURL(event.files[0]);
    }
  }
  onClickRemoveB64(index) {
    this.ochannels.controls[index].get('icon_b64').setValue(null);
  }
  onClickRemoveUrl(index) {
    this.ochannels.controls[index].get('icon_url').setValue(null);
  }
  onKeyPress(event, index) {
    //this.ochannels.controls[index].get('icon_url').setValue(null);
  }

  //funzione per lo status
  getHeadStatus(head: AbstractControl): string {
    if (!head) return '';
    const startVal = head.get('date_start').value;
    const endVal = head.get('date_end').value;

    if (!startVal || !endVal) return '';

    const start = moment(startVal, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate();
    const end = moment(endVal, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate();

    // Calcoliamo la mezzanotte di oggi per un confronto pulito
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (end < today) {
      return 'Expired';
    } else if (start > today) {
      return 'Future';
    } else {
      return 'Active';
    }
  }

  getStatusLabel(head: AbstractControl): string {
    return this.getHeadStatus(head);
  }

  getStatusColorClass(head: AbstractControl): string {
    const status = this.getHeadStatus(head);
    if (status === 'Expired') return 'dot-expired';
    if (status === 'Future') return 'dot-future';
    if (status === 'Active') return 'dot-active';
    return '';
  }

  openActionModal(head: AbstractControl, index: number) {
    this.selectedHead = head as FormGroup;
    this.selectedHeadIndex = index;
    this.selectedHeadStatus = this.getHeadStatus(head);
    this.showActionModal = true;
  }

  countCustomersToUpdate() {
    let clusterHeadId = this.currentPeriodForm.get('cluster_head_id').value;
    if (!clusterHeadId) {
      clusterHeadId = this.currentPeriodForm.get('id').value;
    }
    const tipoCalcolo = this.currentPeriodForm.get('update_customers_type').value;

    if (!clusterHeadId) {
      this.messageService.add({ severity: 'warn', summary: this.translateService.instant('common.attention'), detail: this.translateService.instant('cluster_head.calc_warning') });
      return;
    }

    let endDateForApi = null;
    let callApi = true;

    if (this.modalPeriodStatus === 'Active') {

      if (tipoCalcolo === 'ONLY_ACTIVE') {

        endDateForApi = null;

      } else if (tipoCalcolo === 'CUSTOM_DATE') {
        const dataScelta = this.currentPeriodForm.get('update_customers_custom_date').value;


        if (!dataScelta) {
          this.messageService.add({ severity: 'warn', summary: this.translateService.instant('common.attention'), detail: this.translateService.instant('cluster_head.custom_data_warn') });
          return;
        }


        if (dataScelta instanceof Date) {
          endDateForApi = moment(dataScelta).format('YYYY-MM-DD');
        } else {
          endDateForApi = moment(dataScelta, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD');
        }

      }

    } else if (this.modalPeriodStatus === 'Future') {

      if (tipoCalcolo === 'ONLY_ACTIVE') {
        endDateForApi = null;

      } else if (tipoCalcolo === 'CUSTOM_DATE') {
        const dataScelta = this.currentPeriodForm.get('update_customers_custom_date').value;

        if (!dataScelta) {
          this.messageService.add({ severity: 'warn', summary: this.translateService.instant('common.attention'), detail: this.translateService.instant('cluster_head.custom_data_warn') });
          return;
        }
        endDateForApi = moment(dataScelta, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD');
      }
    }
    console.log("parametri inviati all'API:", {
      idInviato: clusterHeadId,
      dataInviata: endDateForApi

    });

    // chiamata API
    if (callApi) {


      this.clusterHeadService.countCustomers(clusterHeadId, endDateForApi).subscribe(
        (res: any) => {

          if (res && res.rsp_msg && res.rsp_code !== 200 && res.rsp_code !== 0) {
            this.messageService.add({ severity: 'error', summary: 'common.error', detail: res.rsp_msg });
            this.calculatedCustomersCount = null;
            return;
          }

          let targetData = (res && res.rsp_data !== undefined) ? res.rsp_data : res;
          let numeroClienti = 0;

          if (Array.isArray(targetData)) {
            if (targetData.length > 0) {


              const recordEsatto = targetData.find(item => item.clusterHeadId == clusterHeadId || item.id == clusterHeadId);

              if (recordEsatto) {

                if (recordEsatto.totalActiveCustomersAtDate !== undefined && recordEsatto.totalActiveCustomersAtDate !== null) {
                  numeroClienti = recordEsatto.totalActiveCustomersAtDate;
                } else if (recordEsatto.totalActiveCustomers !== undefined && recordEsatto.totalActiveCustomers !== null) {
                  numeroClienti = recordEsatto.totalActiveCustomers;
                } else if (recordEsatto.totalCustomers !== undefined && recordEsatto.totalCustomers !== null) {
                  numeroClienti = recordEsatto.totalCustomers;
                }
              } else {
                console.warn("Il clusterHeadId cercato non è presente nella lista restituita dal server.");
              }

            }
          }
          else if (typeof targetData === 'number') {
            numeroClienti = targetData;
          }
          else if (targetData && typeof targetData === 'object') {
            if (targetData.totalActiveCustomersAtDate !== undefined && targetData.totalActiveCustomersAtDate !== null) {
              numeroClienti = targetData.totalActiveCustomersAtDate;
            } else if (targetData.totalActiveCustomers !== undefined && targetData.totalActiveCustomers !== null) {
              numeroClienti = targetData.totalActiveCustomers;
            } else if (targetData.totalCustomers !== undefined && targetData.totalCustomers !== null) {
              numeroClienti = targetData.totalCustomers;
            }
          }

          this.calculatedCustomersCount = numeroClienti;

        },
        (err) => {
          console.error("Errore API:", err);
        }
      );
    }
  }

  exportValidCustomerDebug(row: any) {
    console.log('FULL ROW DATA:', JSON.parse(JSON.stringify(row)));
    console.log('ROW KEYS:', Object.keys(row));
    this.exportValidCustomer(row.clusterHeadId || row.id);
  }

  exportValidCustomer(clusterHeadId: string) {
    console.log('exportValidCustomer - clusterHeadId:', clusterHeadId, typeof clusterHeadId);

    if (!clusterHeadId) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translateService.instant('common.attention'),
        detail: this.translateService.instant('cluster_head.save_period_message')
      });
      return;
    }


    this.confirmationService.confirm({
      message: this.translateService.instant('cluster_head.exportMessage'),
      header: this.translateService.instant('cluster_head.confirm_export'),
      icon: 'fa fa-download',
      acceptLabel: this.translateService.instant('common.export'),
      rejectLabel: this.translateService.instant('common.cancel'),
      accept: () => {

        this.isLoadingExport = true;
        this.messageService.add({
          severity: 'info',
          summary: this.translateService.instant('cluster_head.exporting'),
          detail: this.translateService.instant('cluster_head.valid_export_preparation')
        });

        const url = `${this.clusterHeadService.baseUrl}/cluster/${clusterHeadId}/exportClusterHeadCustomers?active_only=true`;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Accept', 'text/csv');
        xhr.setRequestHeader('Accept-Company', this.authService.user.selectedCompany.toString());
        xhr.setRequestHeader('Accept-Language', this.authService.sessionHelper.selectedLanguage);
        xhr.setRequestHeader('Authorization', `Bearer ${this.authService.user.token}`);
        xhr.responseType = 'blob';

        xhr.onprogress = (event) => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded / event.total) * 100);
          }
        };

        xhr.onload = () => {
          this.isLoadingExport = false;
          if (xhr.status === 200) {
            const blob = xhr.response;
            const fileName = `cluster_${clusterHeadId}_valid_customers.zip`;
            FileSaver.saveAs(blob, fileName);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant('cluster_head.export_error')
            });
          }
        };

        xhr.onerror = () => {
          this.isLoadingExport = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('common.error'),
            detail: this.translateService.instant('cluster_head.export_error')
          });
          console.error('Error downloading report');
        };

        xhr.send();
      },
      reject: () => {

      }
    });
  }

  emptyValidCustomers(row: any) {

    if (!row.clusterHeadId) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translateService.instant('common.attention'),
        detail: this.translateService.instant('cluster_head.save_period_message')
      });
      return;
    }
    this.confirmationService.confirm({
      message: this.translateService.instant('cluster_head.empty_message'),
      header: this.translateService.instant('cluster_head.confirm_empty'),
      icon: 'fa fa-exclamation-triangle',
      acceptLabel: this.translateService.instant('common.confirm'),
      rejectLabel: this.translateService.instant('common.cancel'),
      accept: () => {
        this.messageService.add({
          severity: 'info',
          summary: this.translateService.instant('cluster_head.emptying'),
          detail: this.translateService.instant('cluster_head.empty_detail')
        });

        //chiamata API
        const payload = {
          date_start: moment((row.date_start), 'DD/MM/YYYY').format('YYYY-MM-DD'),
          date_end: moment(row.date_end, 'DD/MM/YYYY').format('YYYY-MM-DD')
        };
        this.clusterHeadService.emptyCustomers(row.clusterHeadId, payload).subscribe(
          (res) => {
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('common.success'),
              detail: this.translateService.instant('cluster_head.empty_success')
            });

            this.fireNewDataAvailable = !this.fireNewDataAvailable;
          },
          (err) => {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant('cluster_head.empty_error')
            });
          }
        )
      }
    });

  }
  refreshTableDataObjects() {
    throw new Error('Method not implemented.');
  }

  exportAllCustomers(clusterHeadId: String) {

    if (!clusterHeadId) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translateService.instant('common.attention'),
        detail: this.translateService.instant('cluster_head.save_period_message')
      });
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.instant('cluster_head.export_all_message'),
      header: this.translateService.instant('cluster_head.confirm_export'),
      icon: 'fa fa-users',
      acceptLabel: this.translateService.instant('common.export'),
      rejectLabel: this.translateService.instant('common.cancel'),
      accept: () => {
        this.isLoadingExport = true;
        this.messageService.add({
          severity: 'info',
          summary: this.translateService.instant('cluster_head.exporting'),
          detail: this.translateService.instant('cluster_head.total_export_preparation')
        });

        const url = `${this.clusterHeadService.baseUrl}/cluster/${clusterHeadId}/exportClusterHeadCustomers?active_only=false`;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        //KS-7882- BE risponde con csv devo richiedere tutto
        xhr.setRequestHeader('Accept', '*/*');
        xhr.setRequestHeader('Accept-Company', this.authService.user.selectedCompany.toString());
        xhr.setRequestHeader('Accept-Language', this.authService.sessionHelper.selectedLanguage);
        xhr.setRequestHeader('Authorization', `Bearer ${this.authService.user.token}`);
        xhr.responseType = 'blob';

        xhr.onprogress = (event) => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded / event.total) * 100);
          }
        };

        xhr.onload = () => {
          this.isLoadingExport = false;
          if (xhr.status === 200) {
            const blob = xhr.response;
            const fileName = `cluster_${clusterHeadId}_all_customers.zip`;
            FileSaver.saveAs(blob, fileName);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant('cluster_head.export_error')
            });
          }
        };

        xhr.onerror = () => {
          this.isLoadingExport = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('common.error'),
            detail: this.translateService.instant('cluster_head.export_error')
          });
          console.error('Error downloading report');
        };

        xhr.send();
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster/form-cluster-loyalty/form-cluster-loyalty.component.ts